// src/components/PortalVerificacao/SecaoPagamento.tsx
// Seção de pagamento pendente — exibe link + valor + instruções
// CREATED: 2026-05-07 — v1.0

import React, { useState } from 'react';
import { CreditCard, ExternalLink, CheckCircle, Clock, Copy, Check } from 'lucide-react';
import { VerificacaoData, formatCurrency, formatDate } from '../../services/verificacaoService';

interface Props { data: VerificacaoData; }

const SecaoPagamento: React.FC<Props> = ({ data }) => {
  const [linkCopiado, setLinkCopiado] = useState(false);

  const copiarLink = async () => {
    if (!data.paymentLink) return;
    try { await navigator.clipboard.writeText(data.paymentLink); } catch {}
    setLinkCopiado(true);
    setTimeout(() => setLinkCopiado(false), 2000);
  };

  // Pagamento já confirmado pelo admin
  if (data.paymentConfirmedAt) {
    return (
      <div className="rounded-3xl border p-6 shadow-sm" style={{ borderColor: '#065f4444', backgroundColor: '#f0fdf4' }}>
        <div className="flex items-center gap-3">
          <CheckCircle className="w-6 h-6 text-green-600" />
          <div>
            <h3 className="text-base font-black text-green-800">Pagamento Confirmado</h3>
            <p className="text-sm text-green-700 mt-0.5">
              Confirmado em {formatDate(data.paymentConfirmedAt)} · Aguardando liberação completa de acesso.
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Pagamento ainda pendente
if (!data.paymentLink || !!data.paymentConfirmedAt) return null;

  return (
    <div className="rounded-3xl border p-6 shadow-sm" style={{ borderColor: '#7c3aed44', backgroundColor: '#faf5ff' }}>
      {/* Cabeçalho */}
      <div className="flex items-center gap-3 mb-5">
        <div className="p-3 rounded-2xl" style={{ backgroundColor: '#7c3aed1A' }}>
          <CreditCard className="w-6 h-6" style={{ color: '#7c3aed' }} />
        </div>
        <div>
          <h3 className="text-lg font-black" style={{ color: '#1F2328' }}>Pagamento da Filiação</h3>
          <p className="text-sm text-gray-500">Conclua o pagamento para ativar sua filiação</p>
        </div>
      </div>

      {/* Valor */}
      {data.paymentValue && (
        <div className="mb-5 p-5 rounded-2xl bg-white border" style={{ borderColor: '#7c3aed22' }}>
          <p className="text-xs text-gray-500 font-bold uppercase tracking-widest mb-1">Valor da filiação</p>
          <p className="text-4xl font-black" style={{ color: '#7c3aed' }}>
            {formatCurrency(data.paymentValue)}
          </p>
          <p className="text-xs text-gray-400 mt-1">Pagamento único de filiação</p>
        </div>
      )}

      {/* Botão principal */}
      <a
        href={data.paymentLink}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-3 w-full py-4 rounded-2xl font-black text-white text-base transition hover:opacity-90 mb-3"
        style={{ backgroundColor: '#7c3aed' }}
      >
        <CreditCard className="w-5 h-5" />
        Realizar Pagamento Agora
        <ExternalLink className="w-4 h-4" />
      </a>

      {/* Copiar link */}
      <button
        onClick={copiarLink}
        className="flex items-center justify-center gap-2 w-full py-3 rounded-2xl text-sm font-bold border transition hover:opacity-80"
        style={{ borderColor: '#7c3aed33', color: '#7c3aed', backgroundColor: 'white' }}
      >
        {linkCopiado
          ? <><Check className="w-4 h-4 text-green-600" /> Link copiado!</>
          : <><Copy className="w-4 h-4" /> Copiar link de pagamento</>
        }
      </button>

      {/* Info */}
      <div className="mt-5 p-4 rounded-2xl" style={{ backgroundColor: '#7c3aed0D' }}>
        <div className="flex items-start gap-2">
          <Clock className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color: '#7c3aed' }} />
          <div className="text-xs text-gray-600 space-y-1">
            <p><strong>Após o pagamento:</strong></p>
            <p>1. Envie o comprovante para nossa equipe via WhatsApp</p>
            <p>2. Aguarde a confirmação (até 1 dia útil)</p>
            <p>3. Esta página será atualizada com seus dados de acesso</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecaoPagamento;